import { render, staticRenderFns } from "./IconUnsentMessages.vue?vue&type=template&id=73884b02&"
import script from "./IconUnsentMessages.vue?vue&type=script&lang=ts&"
export * from "./IconUnsentMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports